<template>
  <div class="PrivacyPolicyPage">

    <div class="page__wr">
      <section id="1">
        <h2>1. Общие положения</h2>
        <p>Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006&nbsp;№ 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые ООО «Элитком» (далее — Оператор).</p>
        <ol>
          <li>
            <p>Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.</p>
          </li>
          <li>
            <p>Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта
              <a href="https://neboavax.ru/">https://neboavax.ru/</a>.</p>
          </li>
        </ol>
      </section>

      <section id="2">
        <h2>2. Основные понятия, используемые в Политике</h2>
        <dl>
          <dt>2.1. Автоматизированная обработка персональных данных</dt>
          <dd>обработка персональных данных с помощью средств вычислительной техники.</dd>

          <dt>2.2. Блокирование персональных данных</dt>
          <dd>временное прекращение обработки персональных данных (кроме случаев, если обработка необходима для уточнения персональных данных).</dd>

          <dt>2.3. Веб-сайт</dt>
          <dd>совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети Интернет по адресу
            <a href="https://neboavax.ru/">https://neboavax.ru/</a>.
          </dd>

          <dt>2.4. Информационная система персональных данных</dt>
          <dd>совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств.</dd>

          <dt>2.5. Обезличивание персональных данных</dt>
          <dd>действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту.</dd>

          <dt>2.6. Обработка персональных данных</dt>
          <dd>любое действие (операция) или совокупность действий с персональными данными: сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, передача, обезличивание, блокирование, удаление, уничтожение.</dd>

          <dt>2.7. Оператор</dt>
          <dd>государственный или муниципальный орган, юридическое или физическое лицо, организующие и/или осуществляющие обработку персональных данных.</dd>

          <dt>2.8. Персональные данные</dt>
          <dd>любая информация, относящаяся прямо или косвенно к определённому или определяемому Пользователю веб-сайта.</dd>

          <dt>2.9. Персональные данные, разрешённые для распространения</dt>
          <dd>данные, доступ к которым предоставлен субъектом персональных данных путём дачи согласия в порядке, предусмотренном Законом.</dd>

          <dt>2.10. Пользователь</dt>
          <dd>любой посетитель веб-сайта <a href="https://neboavax.ru/">https://neboavax.ru/</a>.</dd>

          <dt>2.11. Предоставление персональных данных</dt>
          <dd>действия, направленные на раскрытие персональных данных определённому лицу или кругу лиц.</dd>

          <dt>2.12. Распространение персональных данных</dt>
          <dd>действия, направленные на раскрытие персональных данных неопределённому кругу лиц или неограниченному кругу лиц.</dd>

          <dt>2.13. Трансграничная передача персональных данных</dt>
          <dd>передача данных на территорию иностранного государства или иностранным лицам.</dd>

          <dt>2.14. Уничтожение персональных данных</dt>
          <dd>действия, в результате которых данные уничтожаются безвозвратно с невозможностью восстановления.</dd>
        </dl>
      </section>

      <section id="3">
        <h2>3. Основные права и обязанности Оператора</h2>
        <h3>3.1. Оператор имеет право:</h3>
        <ul>
          <li>получать от субъекта персональных данных достоверные информацию и/или документы;</li>
          <li>в случае отзыва согласия продолжать обработку при наличии оснований, указанных в Законе;</li>
          <li>самостоятельно определять меры для исполнения требований законодательства.</li>
        </ul>
        <h3>3.2. Оператор обязан:</h3>
        <ul>
          <li>предоставлять субъекту информацию по его запросу;</li>
          <li>организовывать обработку в порядке, установленном законодательством РФ;</li>
          <li>отвечать на обращения субъектов и их представителей;</li>
          <li>сообщать уполномоченному органу по запросу в течение 10 дней;</li>
          <li>публиковать Политику в открытом доступе;</li>
          <li>принимать меры по защите персональных данных;</li>
          <li>прекратить передачу и уничтожить данные в предусмотренных случаях;</li>
          <li>исполнять иные обязанности, предусмотренные Законом.</li>
        </ul>
      </section>

      <section id="4">
        <h2>4. Основные права и обязанности субъектов персональных данных</h2>
        <h3>4.1. Субъекты имеют право:</h3>
        <ul>
          <li>получать информацию об обработке своих данных;</li>
          <li>требовать уточнения, блокирования или уничтожения неполных, устаревших или неточных данных;</li>
          <li>выдвигать условие предварительного согласия при маркетинге;</li>
          <li>отзывать согласие и требовать прекращения обработки;</li>
          <li>обжаловать неправомерные действия Оператора;</li>
          <li>осуществлять иные права, предусмотренные законодательством.</li>
        </ul>
        <h3>4.2. Субъекты обязаны:</h3>
        <ul>
          <li>предоставлять достоверные данные;</li>
          <li>сообщать об изменении своих персональных данных.</li>
        </ul>
        <p>4.3. Лица, передавшие недостоверные сведения без согласия, несут ответственность в соответствии с законодательством РФ.</p>
      </section>

      <section id="5">
        <h2>5. Принципы обработки персональных данных</h2>
        <ol>
          <li>Законность и справедливость обработки.</li>
          <li>Ограничение обработки конкретными, законными целями.</li>
          <li>Запрет объединения несовместимых баз данных.</li>
          <li>Обработка только необходимых данных.</li>
          <li>Соответствие объема данных заявленным целям.</li>
          <li>Точность, достаточность и актуальность данных.</li>
          <li>Срок хранения не дольше, чем требует цель обработки.</li>
        </ol>
      </section>

      <section id="6">
        <h2>6. Цели обработки персональных данных</h2>
        <p><strong>Цель:</strong> информирование Пользователя посредством отправки электронных писем</p>
        <p><strong>Персональные данные:</strong> фамилия, имя, отчество; электронный адрес; номера телефонов</p>
        <p>
          <strong>Правовые основания:</strong> Федеральный закон «Об информации, информационных технологиях и о защите информации» от 27.07.2006 N 149-ФЗ
        </p>
        <p>
          <strong>Виды обработки:</strong> сбор, запись, систематизация, накопление, хранение, уничтожение и обезличивание персональных данных
        </p>
      </section>

      <section id="7">
        <h2>7. Условия обработки персональных данных</h2>
        <ol>
          <li>С согласия субъекта персональных данных.</li>
          <li>Необходимость для выполнения международных договоров или законодательства РФ.</li>
          <li>Необходимость для исполнения судебного акта или иных обязательств.</li>
          <li>Необходимость для исполнения или заключения договора.</li>
          <li>Необходимость для прав и законных интересов Оператора или третьих лиц.</li>
          <li>Обработка общедоступных персональных данных.</li>
          <li>Обработка данных, обязательных к публикации.</li>
        </ol>
      </section>

      <section id="8">
        <h2>8. Порядок сбора, хранения, передачи и других видов обработки</h2>
        <p>Безопасность персональных данных обеспечивается правовыми, организационными и техническими мерами.</p>
        <ul>
          <li>Оператор обеспечивает сохранность и исключает доступ неуполномоченных лиц.</li>
          <li>Данные не передаются третьим лицам, кроме случаев, предусмотренных законодательством или с согласия субъекта.</li>
          <li>Актуализация данных по запросу на
            <a href="mailto:gfcrelfgjujhjcrjge@yandex.ru">gfcrelfgjujhjcrjge@yandex.ru</a>.
          </li>
          <li>Срок обработки определяется целями или договором.</li>
          <li>Отзыв согласия возможен по письму на указанный e-mail с пометкой «Отзыв согласия».</li>
          <li>Сторонние сервисы хранят данные по своим политикам.</li>
          <li>Запреты на передачу не действуют в публичных интересах.</li>
          <li>Обеспечение конфиденциальности на всех этапах.</li>
          <li>Условия прекращения обработки: достижение целей, отзыв согласия, требование субъекта, выявление неправомерной обработки.</li>
        </ul>
      </section>

      <section id="9">
        <h2>9. Перечень действий, производимых Оператором</h2>
        <p>Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение персональных данных, включая автоматизированную обработку.</p>
      </section>

      <section id="10">
        <h2>10. Трансграничная передача персональных данных</h2>
        <ol>
          <li>До начала трансграничной передачи Оператор уведомляет уполномоченный орган.</li>
          <li>До уведомления Оператор получает сведения от иностранных получателей.</li>
        </ol>
      </section>

      <section id="11">
        <h2>11. Конфиденциальность персональных данных</h2>
        <p>Оператор и лица, получившие доступ к данным, обязаны не раскрывать их без согласия субъекта, кроме случаев, предусмотренных федеральным законом.</p>
      </section>

      <section id="12">
        <h2>12. Заключительные положения</h2>
        <ol>
          <li>С разъяснениями можно обращаться по e-mail
            <a href="mailto:gfcrelfgjujhjcrjge@yandex.ru">gfcrelfgjujhjcrjge@yandex.ru</a>.
          </li>
          <li>Любые изменения Политики будут отражены в этом документе. Политика действует бессрочно до замены новой версией.</li>
          <li>Актуальная версия доступна по адресу
            <a href="https://neboavax.ru/privacy-policy/">https://neboavax.ru/privacy-policy/</a>.
          </li>
        </ol>
      </section>
    </div>

  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage"
}
</script>

<style>
.PrivacyPolicyPage{
  color: #0d0d0d;
}
</style>
